import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const AddAgreementMaster = createSlice({
  name: "AddAgreementMaster",
  initialState: {
    isLoading: false,
    api_completed: false,
    isSuccess: false,
    data: [],
  },
  reducers: {
    add_agreement_master: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_add_agreement_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.api_completed = true;
      state.isSuccess = true;
      // SUCCESE(action.payload.message);
    },
    failure_api_call_add_agreement_master: (state, action) => {
      state.api_completed = true;
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = false;
      // FAILED(action.payload);
    },
    add_agreement_isSuccess: (state, action) => {
      state.isSuccess = false;
    },
    add_agreement_master_api_complete: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default AddAgreementMaster.reducer;
export const {
  add_agreement_master,
  success_api_call_add_agreement_master,
  add_agreement_master_api_complete,
  add_agreement_isSuccess,
  failure_api_call_add_agreement_master,
} = AddAgreementMaster.actions;
